
import { Component, Prop, Vue } from "vue-property-decorator";
import CommonUtils from "@/common-utils";
import Constants from "@/constants"

@Component
export default class CommonModalDialog extends Vue {
  @Prop({default: false})
  isAlert!: boolean;
  @Prop()
  width!: string;
  @Prop({default: false})
  large!: boolean;
  @Prop({default: false})
  xLarge!: boolean;
  @Prop({default: false})
  fullSize!: boolean;
  @Prop({default: true})
  isHeader!: boolean;
  @Prop()
  opened!: boolean;
  @Prop({default: false})
  isBottom!: boolean;

  closePop() {
    this.$emit('update:opened', false);
  }
}
